import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'
import { useAppRouter } from 'hooks/useAppRouter/useAppRouter'
import { useTriggerEvents } from 'hooks/useTriggerEvents'
import { getQuizOutcomeContent, quizQuestions } from './helpers'
import { useContext } from 'react'

import { QuizFlowSplash, QuizFlowQuestion, QuizFlowResult } from '.'
import { AnalyticsContext } from '@/providers/AnalyticsProvider'

const QuizFlow = function ({ onCLose }) {
  const {
    state: { isPageLoaded },
  } = useContext(AnalyticsContext)
  const [showQuizState, setShowQuizState] = useState(true)
  const [showQuizQuestions, setShowQuizQuestions] = useState(false)
  const [showQuizResult, setShowQuizResult] = useState(false)
  const [quizResultContent, setQuizResultContent] = useState()
  const { push, query } = useAppRouter()
  const { fireAndForget } = useTriggerEvents()
  const visitId = Cookies.get('eh_visit_id')

  const setQuizComplete = () => {
    fireAndForget({
      event_type: 'app_event',
      event_action: 'app_event',
      nav_link_section: 'PFQ Flow',
      track_event: 'product_fit_quiz_flow_complete',
    })
    if (typeof onCLose === 'function') {
      onCLose()
    }
  }

  const startQuestionsHandler = () => {
    setShowQuizState(false)
    setShowQuizQuestions(true)
  }

  const closeSplashHandler = () => {
    setShowQuizState(false)
    if (typeof onCLose === 'function') {
      onCLose()
    }
  }

  const closeQuestionsHandler = () => {
    setShowQuizQuestions(false)
    if (typeof onCLose === 'function') {
      onCLose()
    }
  }

  const completeQuizHandler = ({ answers }) => {
    const newQuizResultContent = getQuizOutcomeContent({ answers })

    fireAndForget({
      event_type: 'app_event',
      event_action: 'app_event',
      nav_link_section: 'PFQ Questions',
      track_event: 'product_fit_quiz_questions_complete',
      pfq_answers: answers,
      pfq_result: newQuizResultContent,
    })

    setQuizResultContent(newQuizResultContent)
    setShowQuizQuestions(false)

    if (newQuizResultContent) {
      // failsafe
      setShowQuizResult(true)
    }
  }

  const closeResultHandler = () => {
    setQuizComplete()
    setShowQuizResult(false)
  }

  const resultCTAHandler = ({ flowRedirectPath }) => {
    setQuizComplete()
    setShowQuizResult(false)

    if (flowRedirectPath) {
      const queryParams = new URLSearchParams(query)
      // attach the Visit ID
      if (visitId) queryParams.set('visit_id', visitId)
      const redirectUrl = `${flowRedirectPath}${queryParams ? `&${queryParams.toString()}` : ''}`
      push(redirectUrl)
    }
  }

  useEffect(() => {
    if (isPageLoaded) {
      fireAndForget({
        event_type: 'app_event',
        event_action: 'app_event',
        nav_link_section: 'PFQ Questions',
        track_event: 'product_fit_quiz_start',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageLoaded])

  return (
    <>
      {showQuizState && (
        <QuizFlowSplash onStart={startQuestionsHandler} onClose={closeSplashHandler} />
      )}
      {showQuizQuestions && (
        <QuizFlowQuestion
          quizQuestions={quizQuestions}
          onComplete={completeQuizHandler}
          onClose={closeQuestionsHandler}
        />
      )}
      {showQuizResult && (
        <QuizFlowResult
          content={quizResultContent}
          onClose={closeResultHandler}
          onButtonClick={resultCTAHandler}
        />
      )}
    </>
  )
}

export { QuizFlow }
